const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  return {};
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
